import { h } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCreative } from 'swiper';
import 'swiper/css/autoplay';
import 'swiper/css';
import { useEffect, useState } from 'preact/hooks';

const PromoBarSlider = (data) => {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  return (
    <div className="px-[22px] laptop:px-10 w-full overflow-hidden h-full">
      <Swiper
        modules={[Autoplay, EffectCreative]}
        autoplay={{
          delay: data.rotationSpeed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        effect={!isMobile ? 'creative' : undefined}
        creativeEffect={{
          prev: {
            translate: ['-100%', 0, 0],
            opacity: 0
          },
          next: {
            translate: ["20%", 0, 0],
            opacity: 0
          },
        }}
        loop={true}
        slidesPerView={1}
        className="h-full"
      >
        {data.slides.map((slide, i) => (
          <SwiperSlide
            key={i}
            className="rte rte-single-line text-[11px] leading-none laptop:leading-[14px] laptop:text-[12px] transition-opacity !flex items-center opacity-100"
            dangerouslySetInnerHTML={{ __html: slide.text }}
          />
        ))}
      </Swiper>
    </div>
  );
};

export default PromoBarSlider;
